import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { PermIdentity }                             from "@material-ui/icons";
import { FC, default as React }                 from "react";
import { useDispatch }                          from "react-redux";
import MenuType                                 from "../../../domain/menu/MenuType";
import RouterDispatcher                         from "../../../infrastructure/redux/router/RouterDispatcher";

interface Props {
  menuType: MenuType
}

const MenuCustomersButton: FC<Props> = (props: Props) => {
  const {menuType} = props;
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());
  return (
    <>
      {
        menuType === MenuType.CUSTOMER
          ?
          <section className="reska-menu-selected">
            <ListItem button={ true } divider={ true } onClick={ () => routerDispatcher.customers() }>
              <ListItemIcon>
                <PermIdentity/>
              </ListItemIcon>
              <ListItemText primary="顧客管理" className="reska-menu-selected-text"/>
            </ListItem>
          </section>
          :
          <ListItem button={ true } divider={ true } onClick={ () => routerDispatcher.customers() }>
            <ListItemIcon>
              <PermIdentity/>
            </ListItemIcon>
            <ListItemText primary="顧客管理"/>
          </ListItem>
      }
    </>
  );
};

export default MenuCustomersButton;
